let config = {};

export const loadConfig = async () => {
  const response = await fetch('/config.json');
  if (!response.ok) {
    throw new Error('Could not load config');
  }
  config = await response.json();
};

export const getConfig = () => config;